export function createTrainingInstructionExamRecordTableFields (vm) {
  return [
    { key: 'id', prop: 'id', label: '答卷ID', width: 90 },
    { key: 'training_instruction_id', prop: 'training_instruction_id', label: '培训ID', width: 90 },
    { key: 'training_examination_id', prop: 'training_examination_id', label: '考试ID', width: 90 },
    {
      key: 'training_instruction_title',
      prop: 'training_instruction_title',
      label: '培训标题',
      minWidth: 160,
      showOverflowTooltip: true,
    },
    { key: 'userid', label: '用户ID', width: 90, formatter: row => row.userid },
    { key: 'realname', prop: 'realname', label: '真实姓名', minWidth: 100, showOverflowTooltip: true },
    { key: 'region_name', prop: 'region_name', label: '省市区', minWidth: 160, showOverflowTooltip: true },
    {
      key: 'target_usertype',
      label: '用户类型',
      width: 110,
      slot: 'emptyText',
      textKey: 'target_usertype_name',
    },
    {
      key: 'source_type',
      label: '来源',
      width: 110,
      slot: 'emptyText',
      textKey: 'source_type_name',
    },
    { key: 'project', label: '项目', minWidth: 160, slot: 'subId', nameKey: 'project_name', idKey: 'projectid' },
    { key: 'batch', label: '批次', minWidth: 160, slot: 'subId', nameKey: 'batch_name', idKey: 'batchid' },
    { key: 'task', label: '任务', minWidth: 160, slot: 'subId', nameKey: 'task_title', idKey: 'taskid' },
    { key: 'examination_submitted_at', prop: 'examination_submitted_at', label: '提交时间', width: 170 },
    { key: 'examination_duration_text', prop: 'examination_duration_text', label: '用时', width: 90 },
    { key: 'open_book_exam_text', prop: 'open_book_exam_text', label: '是否开卷', width: 90 },
    {
      key: 'examination_score',
      label: '得分',
      width: 100,
      formatter: row => row.examination_score_text || '-',
    },
    {
      key: 'examination_status',
      label: '状态',
      width: 100,
      slot: 'tag',
      formatter: row => row.examination_status_name,
      tagClass: row => vm.getExamStatusTagClass(row.examination_status),
    },
  ]
}



// WEBPACK FOOTER //
// ./src/views/training/training-instruction-exam-record-table.fields.js